<template>
    <div>
         <base-header type="gradient-login_varient" class="pb-2 pb-2 pt-5 pt-md-8">
          <div class="row">
            <div class="col-xl-3 col-lg-6">
                <stats-card title="Montant à payer"
                            type="gradient-red"
                            :sub-title="allfournisseurs.montantapayer"
                            icon="fa fa-dollar-sign"
                            class="mb-4"
                >
                    <template slot="footer">
                        <span class="text-nowrap">Date max la plus proche : </span>
                        <span class="text-success mr-2">{{allfournisseurs.datemaxreglement}}</span>
                    </template>
                </stats-card>
            </div>
            <div class="col-xl-3 col-lg-6">
                <stats-card title="Montant payé"
                            type="gradient-green"
                            :sub-title="allfournisseurs.montantpaye"
                            icon="fa fa-dollar-sign"
                            class="mb-4"
                >
                    <template slot="footer">
                        <span class="text-nowrap"></span>
                        <span class="text-success mr-2"></span>
                    </template>
                </stats-card>
            </div>
          </div>
        </base-header>
        <div class="container-fluid mt--4">
            <div class="row mt-5">
                <div class="col">
                    <dashboard-table @allfournisseurschange="allfournisseurschange" title="Dashboard"></dashboard-table>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import DashboardTable from './Tables/DashboardTable'
  export default {
    name: 'tables',
    components: {
      DashboardTable
    },
    data() {
      return {
        allfournisseurs: {
            'idFournisseur':0,
            'nom':'Tous fournisseurs confondus',
            'montantapayer':0,
            'montantpaye':0,
            'datemaxreglement':0  
        }
      }
    },
    methods: {
      allfournisseurschange(value)  {
        this.allfournisseurs = value
      }
    },
  };
</script>
<style></style>
